export default __webpack_public_path__ + "img_220720_Women_in_Finance_main_s_fullcolor_rgb.svg";